export default "__VITE_ASSET__CWX3CLFs__"